function iframeSandboxDomainStrategy(metaSiteId) {
  const iframeSandboxDomainParams = {};
  if (metaSiteId) {
    const host = "filesusr";
    iframeSandboxDomainParams.iframeSandboxDomain = `https://${metaSiteId}.${host}.com`;
  }
  return iframeSandboxDomainParams;
}
export {
  iframeSandboxDomainStrategy as default
};
//# sourceMappingURL=iframeSandboxDomainStrategy.js.map
